var render = function render(_c,_vm){return _c('form-group',{class:[_vm.data.staticClass, {'error' : _vm.props.v ? _vm.props.v.$error : null}],attrs:{"label":_vm.props.label,"help":_vm.props.help}},[_c('div',{staticClass:"form-check"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","id":"flexCheckIndeterminate"},domProps:{"checked":_vm.props.value},on:{"change":($event) => {
                      _vm.listeners.input && _vm.listeners.input($event.target.checked);
                      if(_vm.props.v) {
                           _vm.props.v.$touch();
                      }
                      _vm.listeners.changed && _vm.listeners.changed($event.target.checked);
                    }}}),_c('label',{staticClass:"form-check-label",attrs:{"for":"flexCheckIndeterminate"}},[_vm._v(" "+_vm._s(_vm.props.text)+" ")]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }